import React from 'react';
import { Link } from 'react-router-dom';
import { EpicDashboard } from '../components/dashboard/EpicDashboard';
import { Header } from '../components/layout/Header';
import { Button, PageHeader } from '../components/ui';

/** Epic Dashboard mounted at "/" (auth-protected). */
export const EpicDashboardPage: React.FC = () => {
  return (
    <div data-testid="epic-dashboard-container" className="min-h-screen bg-slate-50">
      <Header title="Epics" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 space-y-4">
        <PageHeader
          title="Epics"
          description="Everything Forge is working on across your projects, by phase. Cards are colour-coded by project; click one for stories and live agent activity."
          actions={
            <Link to="/epics/new">
              <Button variant="primary" size="md" data-testid="dashboard-new-epic">
                New epic
              </Button>
            </Link>
          }
        />
        <EpicDashboard />
      </main>
    </div>
  );
};

export default EpicDashboardPage;
